module.exports = __webpack_public_path__ + "static/affinity-310e94908e04be62dfd8ecee64149d4a.png";